import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProcedureSectionVisibilityService } from '@shared/services/procedure-section-visibility.service';

@Injectable()
export class ProcedureSelectedPageFacade {
	readonly isApplianceProcedureSectionVisible$: Observable<boolean> = this.sectionVisibilityService.isApplianceProcedureSectionVisible$;
	readonly isScanSurgicalGuideVisible$: Observable<boolean> = this.sectionVisibilityService.isScanSurgicalGuideVisible$;
	readonly isDentureDetailsVisible$: Observable<boolean> = this.sectionVisibilityService.isDentureDetailsVisible$;
	readonly isInvisalignDetailsVisible$: Observable<boolean> = this.sectionVisibilityService.isInvisalignDetailsVisible$;
	readonly isToothDiagramVisible$: Observable<boolean> = this.sectionVisibilityService.isTeethDiagramAreaVisible$;
	readonly isSendToIDSMessageVisible$: Observable<boolean> = this.sectionVisibilityService.isSendToIDSMessageVisible$;

	constructor(private readonly sectionVisibilityService: ProcedureSectionVisibilityService) {}
}
